import { useState } from "react";
import { useInterval } from "usehooks-ts";
import { isOptimizelyEnabled } from "lib/utils/optimizely";

export const MAX_RETRIES_OPTIMIZELY = 3;

export const RETRIES_INTERVAL = 700;

export const useIsOptimizelyEnabled = () => {
  const [isOptimizelyActive, setIsOptimizelyActive] = useState(isOptimizelyEnabled());

  const [tries, setTries] = useState(0);

  useInterval(
    () => {
      const optimizelyActive = isOptimizelyEnabled();

      if (optimizelyActive) {
        setIsOptimizelyActive(true);
        setTries(MAX_RETRIES_OPTIMIZELY + 1);

        return;
      }

      setTries((prevValue) => prevValue + 1);
    },
    tries < MAX_RETRIES_OPTIMIZELY ? RETRIES_INTERVAL : null
  );

  return isOptimizelyActive;
};
